import { SERVER_URL } from "../../config"
import download from "downloadjs";

/**
 * Baixa o CSV do histórico de envio armazenado no S3
 * @param {string} cycleLogisticSendHistoryId - ID do histórico de envio
 * @returns {Promise<void>}
 */
export const downloadCsvSendHistory = async (cycleLogisticSendHistoryId, cycleId) => {
    const response = await fetch(`${SERVER_URL}/cycles-logistics-send-history/${encodeURIComponent(cycleLogisticSendHistoryId)}/download-csv`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Erro ao baixar CSV' }));
        throw new Error(error.message || 'Erro ao baixar CSV de envio');
      }

      const blob = await response.blob();

      const fileName = `pedidos-enviados-${cycleId}-${cycleLogisticSendHistoryId}.csv`;
      download(blob, fileName);
}